import React from "react";
import { Link } from "react-router-dom";
import { contact, profile } from "../../data/profile";
import SocialLinks from "../ui/SocialLinks";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer__inner">
        <p>
          © {year} {profile.name}. Built with React.
        </p>

        <nav className="footer__links" aria-label="Footer navigation">
          <Link to={{ pathname: "/", hash: "#projects" }}>Projects</Link>
          <Link to="/resume">Resume</Link>
          <a href={`mailto:${contact.email}`}>Email</a>
        </nav>

        <SocialLinks variant="compact" />
      </div>
    </footer>
  );
}

export default Footer;
